import type { CrmSubjectFields, IssueCategory } from '../types/sales';

/** The kinds of issue, in the order offered (HHNodeServer salesCrmService.ISSUE_CATEGORIES). */
export const ISSUE_CATEGORIES: { value: IssueCategory; label: string }[] = [
  { value: 'damaged', label: 'Damaged' },
  { value: 'short', label: 'Short' },
  { value: 'wrong_item', label: 'Wrong item' },
  { value: 'quality', label: 'Quality' },
  { value: 'late', label: 'Late' },
  { value: 'pricing', label: 'Pricing' },
  { value: 'other', label: 'Other' },
];

export function categoryLabel(category: IssueCategory | null | undefined): string {
  return ISSUE_CATEGORIES.find((c) => c.value === category)?.label ?? 'Issue';
}

export interface SubjectLink { label: string; to: string | null }

/**
 * What a note or follow-up is about, as links, leaving out what the page is
 * already showing: "Order SO-356 · Eureka 20cm", "Load LD-12".
 */
export function subjectLinks(
  row: CrmSubjectFields,
  showing: { customer?: boolean; order?: boolean; load?: boolean } = {},
): SubjectLink[] {
  const out: SubjectLink[] = [];
  if (row.customer_id && row.customer_name && !showing.customer) {
    out.push({ label: row.customer_name, to: `/accounts/customers/${row.customer_id}?tab=notes` });
  }
  if (row.order_id && !showing.order) out.push({ label: `Order ${row.order_number ?? row.order_id}`, to: `/nursery/orders/${row.order_id}` });
  if (row.order_line_id && row.order_line_label) out.push({ label: row.order_line_label, to: null });
  if (row.load_id && !showing.load) out.push({ label: `Load ${row.load_number ?? row.load_id}`, to: `/nursery/loads/${row.load_id}` });
  return out;
}
